import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Badge } from './ui/badge';
import { Package, Plus } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Reusable Asset/Asset Selector
 * Used across: ScheduleTab, CalendarScheduler, ServicesTab
 */
const AssetSelector = ({ 
  assets = [], 
  value, 
  onChange, 
  placeholder = "Select asset...",
  showUnassign = true,
  showAddButton = false,
  onAddClick,
  disabled = false,
  showOnlyActive = true,
  showCapacity = false,
  className = ""
}) => {
  const filteredAssets = showOnlyActive 
    ? assets.filter(v => v.active !== false)
    : assets;

  return (
    <div className="flex gap-2">
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {showUnassign && (
            <SelectItem value="none">
              <span className="text-gray-500 italic">Unassign</span>
            </SelectItem>
          )}
          {filteredAssets.length === 0 ? (
            <div className="px-2 py-4 text-sm text-gray-500 text-center">
              No assets available
            </div>
          ) : (
            filteredAssets.map((asset) => (
              <SelectItem key={asset.id} value={asset.id}>
                <div className="flex items-center gap-2">
                  <Package className="w-3 h-3 text-cyan-600" />
                  <span>{asset.name}</span>
                  {showCapacity && asset.capacity && (
                    <Badge variant="outline" className="text-xs">
                      {asset.capacity} pax
                    </Badge>
                  )}
                  {!asset.active && (
                    <Badge variant="secondary" className="text-xs">
                      Inactive
                    </Badge>
                  )}
                </div>
              </SelectItem>
            ))
          )}
          {showAddButton && (
            <SelectItem 
              value="__add_new__" 
              className="text-blue-600 font-semibold border-t mt-1 pt-2"
            >
              ➕ Add Asset
            </SelectItem>
          )}
        </SelectContent>
      </Select>
      {showAddButton && onAddClick && (
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={onAddClick}
          className="flex-shrink-0"
        >
          <Plus className="w-4 h-4 mr-1" />
          Add
        </Button>
      )}
    </div>
  );
};

export default AssetSelector;
